import Vue from "vue";
import {
  Layout,
  Row,
  Col,
  Form,
  Input,
  Checkbox,
  Divider,
  Card,
  Menu,
  Dropdown,
  Popover,
  Badge,
  Switch,
  Button,
  Icon,
  Table,
  Tabs,
  Popconfirm,
  message,
  notification,
  Select,
  Alert,
  Tooltip,
  List,
  Spin,
  Anchor,
  Avatar,
  Modal,
  DatePicker,
  Breadcrumb,
  Skeleton,
  Radio,
  InputNumber,
  Tag,
  Upload,
  Timeline,
  Progress,
  Empty,
  Steps,
  Result,
  Pagination,
  Statistic,
  TimePicker,
  Rate,
  Descriptions
} from "ant-design-vue";
import "ant-design-vue/dist/antd.css";

Vue.prototype.$form = Form;
Vue.prototype.$message = message;
Vue.prototype.$notification = notification;

Vue.use(Layout);
Vue.use(Row);
Vue.use(Col);
Vue.use(Form);
Vue.use(Alert);
Vue.use(Input);
Vue.use(Checkbox);
Vue.use(Divider);
Vue.use(Card);
Vue.use(Menu);
Vue.use(Dropdown);
Vue.use(Select);
Vue.use(Popover);
Vue.use(Badge);
Vue.use(Switch);
Vue.use(Button);
Vue.use(Icon);
Vue.use(Table);
Vue.use(Tabs);
Vue.use(Popconfirm);
Vue.use(Tooltip);
Vue.use(List);
Vue.use(Spin);
Vue.use(Anchor);
Vue.use(Avatar);
Vue.use(Modal);
Vue.use(DatePicker);
Vue.use(Breadcrumb);
Vue.use(Skeleton);
Vue.use(Radio);
Vue.use(InputNumber);
Vue.use(Tag);
Vue.use(Upload);
Vue.use(Timeline);
Vue.use(Progress);
Vue.use(Empty);
Vue.use(Steps);
Vue.use(Result);
Vue.use(Pagination);
Vue.use(Statistic);
Vue.use(TimePicker);
Vue.use(Rate);
Vue.use(Descriptions);
